import React from "react";
import RestaurantSection from "./RestaurantSection";
import MosqueSection from "./MosqueSection";
import ENumberCheckSection from "./ENumberCheckSection";
import { Stack } from "@mui/material";
import Header from "../common-component/Header";

const Home = () => {
  return (
    <Stack gap={10}>
      <Stack>
        <Header
          heading="Discover Halal World"
          subHeading="Your Gateway To Halal Dining And Prayer And Much More"
          subSubHeading="Find Halal Restaurants and Mosques Worldwide"
        />
      </Stack>
      <Stack>
        <RestaurantSection />
      </Stack>
      <Stack>
        <MosqueSection />
      </Stack>
      <Stack>
        <ENumberCheckSection />
      </Stack>
    </Stack>
  );
};

export default Home;
